export const brandPaymentStatusLabel = (status) => {
  const map = {
    pending: "결제 요청 중",
    paid: "결제완료",
    failed: "결제실패",
    cancelled: "환불신청",
    refunded: "환불완료",
  };

  return map[status] ?? status;
};

export const brandPaymentStatusClass = (status) => {
  if (status === "cancelled") {
    return "bg-[#fff1f0] text-[#d4380d]";
  }

  if (status === "pending") {
    return "bg-[#fff7e6] text-[#d46b08]";
  }

  if (status === "paid") {
    return "bg-[#e6f4ff] text-[#1677ff]";
  }

  if (status === "refunded") {
    return "bg-[#e8fff3] text-[#009d5c]";
  }

  return "bg-[#f1f5f9] text-[#64748b]";
};
